import { Component, OnInit } from '@angular/core';
import { AbcRegistrationComponent } from '../abc-registration/abc-registration.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-deb-registration',
  templateUrl: './deb-registration.component.html',
  styleUrls: ['./deb-registration.component.scss']
})
export class DebRegistrationComponent implements OnInit {
  dialogRef: MatDialogRef<any>;
  debRegisterationForm: FormGroup;
  debID: any;

  constructor(
    private dialog: MatDialog,
    public router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {

        this.debRegisterationForm = this.fb.group({
          DEBID: new FormControl('', [Validators.required]),
            });
    
    
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  createABCID() { 
    this.redirect('abc-registration');
    // const dialogRef = this.dialog.open(AbcRegistrationComponent, {
    //   width: '110vh',
    //   data: {key : "New"},
    //   disableClose: true   
    // });  
    // dialogRef.afterClosed().subscribe(result => {
    // });
  }

  createDEBID() {
    this.redirect('https://deb.ugc.ac.in/StudentDEBId');
  }

  getUserDetails() {
    if(this.debRegisterationForm.controls['DEBID'].value == '') {
      this.debRegisterationForm.get('DEBID').markAsTouched();
    }
    else {
      this.debID = this.debRegisterationForm.controls['DEBID'].value;
      this.router.navigate(['/deb-userdetails'], {
       queryParams: { debID: this.debID },
  
      });
    }
  
  }

  loginPage(){
    this.router.navigate(['/student-login']);
  }

}
